/**
 * Created by Ning Jiang on 4/25/2018.
 */

import {TweenLite} from "gsap";

export class ShakingAnimation extends PIXI.Sprite {

    private _stopped:boolean = true;

    constructor(texture?:PIXI.Texture) {
        super(texture);
    }

    public shake(speed:number, maxOffset:number):void {
        this._stopped = false;

        TweenLite.fromTo(this, speed,
            {
                x : this.x + ShakingAnimation.getShakeOffset(maxOffset),
                y : this.y + ShakingAnimation.getShakeOffset(maxOffset)
            },
            {
                x : this.x,
                y : this.y,
                onComplete : () => {
                    if(this._stopped) {
                        return;
                    }
                    this.shake(speed, maxOffset)
                },
                clearProps : "x,y"
            });
    }

    public stopShake():void {
        this._stopped = true;
    }

    private static getShakeOffset(offset:number):number {
        return Math.floor(Math.random() * (offset + offset + 1) - offset);
    }
}